/**
 * A builder for the data layers component instances
 */
export class DataLayerComponentBuilder {
    componentInfo;
    componentAttributes;
    additionalInformation = {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() { }
    /**
     * Creates a new instance of the component builder
     * @returns {DataLayerComponentBuilder} a new builder instance
     */
    static new() {
        return new DataLayerComponentBuilder();
    }
    /**
     * Specifies the component info object of the data layer component.
     * @param {ComponentInfo} componentInfo the info object of the component
     * @returns {DataLayerComponentBuilder} the component builder
     */
    withComponentInfo(componentInfo) {
        this.componentInfo = componentInfo;
        return this;
    }
    /**
     * Specifies the component attributes of the data layer component.
     * @param {ComponentAttributes} componentAttributes the attributes of the component
     * @returns {DataLayerComponentBuilder} the component builder
     */
    withComponentAttributes(componentAttributes) {
        this.componentAttributes = componentAttributes;
        return this;
    }
    /**
     * Specifies additional information which could be passed to the component object.
     * @param additionalInformation the additional information which should be added
     * @returns {DataLayerComponentBuilder} the component builder
     */
    withAdditionalInformation(additionalInformation) {
        this.additionalInformation = additionalInformation;
        return this;
    }
    /**
     * Builds the component for the data layer with the specified parts.
     * If there are no componentInfo and componentAttributes the builder will return undefined.
     * @returns {DataLayerComponent | undefined} a component or undefined if mandatory parts are missing.
     */
    build() {
        if (!this.componentInfo || !this.componentAttributes) {
            return undefined;
        }
        return {
            ...this.additionalInformation,
            componentInfo: this.componentInfo,
            attributes: this.componentAttributes,
        };
    }
}
